import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-galeri-standard-template',
  templateUrl: './galeri-standard-template.component.html',
  styleUrls: ['./galeri-standard-template.component.css']
})
export class GaleriStandardTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/galeri-standard-template/galeri-standard-template.component.ts